export const aboutUrl = () => { return '/about' }
export const westrumUrl = () => { return '/about/westrum'}